module.exports = __webpack_public_path__ + "img/image1.177bfea5.png";